export default (state = {}, action) => {
  switch (action.type) {
    case 'GET_BANNERS':
      return { ...state, banners: action.banners };
    case 'GET_BANNER':
      return { ...state, banner: action.banner };
    default:
      return state;
  }
};
